import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { TiptapEditorUpdatePayload } from 'client/components/core/tiptap-editor'
import { useManagement } from 'client/store'
import managementSelectors from 'client/store/management/managementSelectors'
import { updateEntity } from 'client/store/page/pageActions'
import { EntityProps } from 'client/types'
import React from 'react'
import { useDispatch } from 'react-redux'
import { BaseEditorCheckbox } from 'src/editor/shared/entities/base-editor-checkbox'
import { CheckboxEntityInterface } from 'src/shared/entities/checkbox/checkbox-entity.schema'

const Checkbox = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<CheckboxEntityInterface>) => {
  const dispatch = useDispatch()
  const isEditing = useManagement(m =>
    managementSelectors.isEditing(m, entity.id),
  )

  const updateText = (payload: TiptapEditorUpdatePayload) => {
    dispatch(
      // @ts-expect-error
      updateEntity({
        ...entity,
        ...payload,
      }),
    )
  }

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <BaseEditorCheckbox
        entityOrSubEntity={entity}
        checked={false}
        // biome-ignore lint/suspicious/noEmptyBlockStatements: <explanation>
        onChange={() => {}}
        isEditing={isEditing}
        updateText={updateText}
      />
    </BaseEntityNew>
  )
}

export default Checkbox
